// Mock data — Rekha Krishnamurthy · editorial "contact sheet" design (search-vibe-hub replica)

export const brand = {
  logo: "/logo.png",
  siteUrl: "https://rekhakrishnamurthy.com/",
  name: "REKHA",
  surname: "KRISHNAMURTHY",
  role: "Bridal Makeup Artist",
  phone: "+91 98454 80507",
  whatsapp: "+91 98454 80507",
  email: "hello@rekhakrishnamurthy.in",
  location: "1st Floor, 1314, 32nd Cross Rd, 1st Stage, Kumaraswamy Layout, Bengaluru, Karnataka 560070, India",
  instagram: "@makeupbyrekhakrishnamurthy",
  instagramUrl: "https://www.instagram.com/makeupbyrekhakrishnamurthy/",
  facebookUrl: "https://www.facebook.com/makeupbyrekhakrishnamurthy/",
  twitterUrl: "https://x.com/MakeupbyRekha",
  linkedinUrl: "https://www.linkedin.com/in/rekha-krishnamurthy-6b998839",
  whatsappUrl: "https://wa.me/919845480507?text=Hello!%20I%20am%20looking%20for%20a%20makeup%20artist.",
};

export const navLinks = [
  { label: "About", to: "about" },
  { label: "Look Lab", to: "looklab" },
  { label: "Services", to: "services" },
  { label: "Try-On", to: "studio" },
  { label: "Pricing", to: "pricing" },
  { label: "Portfolio", to: "portfolio" },
  { label: "Academy", to: "academy" },
  { label: "Contact", to: "contact" },
];

export const sampleFace = "/sample-face.jpg";

export const studioLooks = [
  { name: "Bridal Classic", lips: "#B3122E", blush: "#E8788A", eyes: "#8A4B2E" },
  { name: "Engagement Rose", lips: "#D9536F", blush: "#F0A0B0", eyes: "#C58A72" },
  { name: "Party Fuchsia", lips: "#E62E6B", blush: "#F28FB0", eyes: "#6E2C3C" },
  { name: "Editorial Plum", lips: "#7A1F3D", blush: "#D98A9C", eyes: "#4A2530" },
  { name: "Soft Nude", lips: "#C98A7A", blush: "#EFC0B4", eyes: "#B89078" },
];

export const studioShades = {
  lips: ["#B3122E", "#E62E6B", "#D9536F", "#7A1F3D", "#C98A7A", "#F0668B", "#9C2A4A", "#E0785A"],
  blush: ["#E8788A", "#F0A0B0", "#F28FB0", "#D98A9C", "#EFC0B4", "#E9A18F"],
  eyes: ["#8A4B2E", "#C58A72", "#6E2C3C", "#4A2530", "#B89078", "#D4A5A5"],
};

export const heroVideo = "/hero-bg.mp4";
export const heroVideoWebm = "/hero-bg.webm";
export const heroVideoPoster = "/hero-poster.jpg";

export const heroStats = [
  { value: "14+", label: "Years in craft" },
  { value: "500+", label: "Brides styled" },
  { value: "4.9", label: "Google rating" },
];

export const locationTicker = [
  "Bridal Makeup Bangalore", "HSR Layout", "JP Nagar", "Jayanagar", "Banashankari", "Self Grooming Classes",
];

export const aboutStats = [
  { value: "14 yrs", label: "Professional practice" },
  { value: "500+", label: "Weddings & shoots" },
  { value: "120+", label: "Artists trained" },
];

export const whoWeServe = [
  { key: "A", title: "Brides-to-be", desc: "From the first trial to the last mandap look — a bridal makeup artist in Bangalore who plans every event with you." },
  { key: "B", title: "Engagement & Pre-Wedding", desc: "Soft, camera-ready glam for rings, shoots and sangeet nights." },
  { key: "C", title: "Premium / Luxury Brides", desc: "Full-day exclusivity, top-shelf products, and a dedicated team for high-touch weddings." },
  { key: "D", title: "Corporate & Professional Events", desc: "Polished, understated makeup for launches, conferences and on-camera work." },
  { key: "E", title: "South Indian Brides", desc: "Traditional draping, temple jewellery styling and looks true to South Indian bridal ritual — a specialty, not an add-on." },
];

export const services = [
  { no: "01", title: "Bridal", desc: "HD & airbrush bridal makeup with a trial session, draping, and touch-up kit for the full wedding day.", cta: "Explore Bridal", image: "https://images.unsplash.com/photo-1610173827043-9db50e0d8ef9" },
  { no: "02", title: "Engagement", desc: "Soft-glam looks built for close-up photography and champagne-lit rooms.", cta: "Explore Engagement", image: "https://images.unsplash.com/photo-1594647210801-5124307f3d51" },
  { no: "03", title: "Non-Bridal", desc: "Polished, camera-ready looks for the wedding party, family, and guests.", cta: "Explore Non-Bridal", image: "https://images.unsplash.com/photo-1587271315307-eaebc181c749" },
  { no: "04", title: "Party", desc: "Bold or bare, tuned to your event and lighting — always long-wear.", cta: "Explore Party", image: "https://images.unsplash.com/photo-1708735808460-2b131ddefb27" },
  { no: "05", title: "Editorial", desc: "Concept-led makeup for magazine covers, campaigns, and creative sets.", cta: "Explore Editorial", image: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2" },
  { no: "06", title: "Fashion", desc: "Runway-ready faces built to hold up under stage light and quick changes.", cta: "Explore Fashion", image: "https://images.unsplash.com/photo-1747847471528-7b95ea7a4c39" },
  { no: "07", title: "Self Makeup Classes", desc: "Hands-on self-grooming classes so you can do your own everyday, event and touch-up makeup with confidence — starting at ₹999.", cta: "Explore Self Grooming Classes", image: "https://images.unsplash.com/photo-1551184451-76b762941ad6" },
];

export const pricing = [
  { price: "Starting ₹7,999/person/session", title: "Party Makeup", desc: "Event-ready glam, no visit charge." },
  { price: "Starting ₹9,999/person/session", title: "Non-Bridal Makeup", desc: "For the wedding party, family & guests." },
  { price: "Starting ₹19,999/session", title: "Engagement Makeup", desc: "Soft-glam for rings & pre-wedding shoots." },
  { price: "Starting ₹9,999 onwards", title: "Fashion Makeup", desc: "Customised looks for portfolio & fashion shoots." },
  { price: "₹4,999/session", title: "Groom Makeup", desc: "Camera-ready grooming for the big day." },
  { price: "Starting ₹29,999/session", title: "Bridal Makeup", desc: "HD/airbrush, trial included, no visit charge.", featured: true },
];

export const areas = ["HSR Layout", "JP Nagar", "Jayanagar", "Banashankari", "+ Bangalore-wide on request"];

export const portfolio = [
  { id: "001", cat: "Bridal", caption: "Bridal · f/2.8 · Golden Hour", image: "https://images.unsplash.com/photo-1610173827043-9db50e0d8ef9" },
  { id: "002", cat: "Reels", caption: "Reel · Look Trial", image: "https://images.unsplash.com/photo-1594647210801-5124307f3d51" },
  { id: "003", cat: "Editorial", caption: "Editorial · Studio Flash", image: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2" },
  { id: "004", cat: "Fashion", caption: "Fashion · Backstage", image: "https://images.unsplash.com/photo-1747847471528-7b95ea7a4c39" },
  { id: "005", cat: "Bridal", caption: "Bridal · Airbrush Base", image: "https://images.unsplash.com/photo-1684868268327-7e5590bcfbd6" },
  { id: "006", cat: "Reels", caption: "Reel · GRWM", image: "https://images.unsplash.com/photo-1551184451-76b762941ad6" },
  { id: "007", cat: "Editorial", caption: "Editorial · Cover Story", image: "https://images.unsplash.com/photo-1677691257363-eebd2abeafec" },
  { id: "008", cat: "Bridal", caption: "Bridal · Reception", image: "https://images.unsplash.com/photo-1587271315307-eaebc181c749" },
  { id: "009", cat: "Fashion", caption: "Fashion · Runway", image: "https://images.unsplash.com/photo-1708735808460-2b131ddefb27" },
];

export const portfolioFilters = ["All Frames", "Bridal", "Editorial", "Fashion", "Reels"];

export const reels = [
  { title: "Airbrush base, start to finish", time: "0:34", image: "https://images.unsplash.com/photo-1594647210801-5124307f3d51" },
  { title: "Bridal trial walkthrough", time: "0:51", image: "https://images.unsplash.com/photo-1610173827043-9db50e0d8ef9" },
  { title: "Editorial smoky eye", time: "0:22", image: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2" },
  { title: "Draping tips for sarees", time: "1:04", image: "https://images.unsplash.com/photo-1587271315307-eaebc181c749" },
  { title: "Runway quick-change", time: "0:40", image: "https://images.unsplash.com/photo-1747847471528-7b95ea7a4c39" },
];

export const process = [
  { no: "01", title: "Enquiry & consultation", desc: "Share your date, venue and vision — we scope the right package and hold your slot." },
  { no: "02", title: "Look trial", desc: "We finalise base, eyes and draping together, well ahead of the event." },
  { no: "03", title: "Wedding day", desc: "On time, exclusively yours — no double bookings, ever." },
  { no: "04", title: "Touch-up & support", desc: "A touch-up kit and on-call support for the rest of your celebrations." },
];

export const academyTracks = [
  "Professional HD & bridal certification",
  "Airbrush machine masterclass",
  "Self-grooming & everyday makeup classes",
];
export const academyImage = "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2";

export const loyaltyPoints = [
  "Free reward on joining the community",
  "Loyalty points on every booking, redeemable on future services",
  "Early access to seasonal offers & class dates",
];
export const loyaltyImage = "https://images.unsplash.com/photo-1594647210801-5124307f3d51";

export const testimonials = [
  { text: "Rekha did a great job dressing me up for my engagement — very polite and great at her work. I'd definitely recommend her.", name: "Harshita Naik" },
  { text: "Thank you for the wonderful looks on my wedding day. You made me feel so comfortable and confident — amazing skills.", name: "Rumini Shesha" },
  { text: "My cousin planned her wedding from the US — one phone call and every worry was put to rest. Absolutely loved her work.", name: "Nandini" },
];

export const instagramFeed = [
  { caption: "Golden-hour bridal glow ✨", likes: "1,204", comments: "38", image: "https://images.unsplash.com/photo-1600685890506-593fdf55949b" },
  { caption: "Red & gold, always a classic 💃", likes: "982", comments: "21", image: "https://images.unsplash.com/photo-1677691257363-eebd2abeafec" },
  { caption: "Trial day magic — base built to last 12 hrs", likes: "1,540", comments: "54", image: "https://images.unsplash.com/photo-1684868268327-7e5590bcfbd6" },
  { caption: "Temple jewellery + soft eye 👑", likes: "2,110", comments: "76", image: "https://images.unsplash.com/photo-1587271315307-eaebc181c749" },
  { caption: "Reception look, all airbrush 🤍", likes: "876", comments: "19", image: "https://images.unsplash.com/photo-1610173827043-9db50e0d8ef9" },
  { caption: "Behind the brush at the studio 🎨", likes: "1,332", comments: "44", image: "https://images.unsplash.com/photo-1551184451-76b762941ad6" },
];

export const faqs = [
  { q: "How far in advance should I book?", a: "For wedding-season dates (Oct–Feb), 4–6 months' notice keeps your date and trial slot secure. Off-season bookings can often be confirmed within a few weeks." },
  { q: "HD vs. Airbrush makeup — what's the difference?", a: "HD makeup uses light-reflecting, high-definition products applied by hand for a flawless close-up finish. Airbrush sprays a fine, even mist for an ultra-lightweight, long-wear base — ideal for full-day weddings and hot, humid weather." },
  { q: "Do you travel for destination weddings?", a: "Yes. Rekha travels across India for destination weddings and fashion assignments. Travel and stay are scoped transparently at consultation." },
  { q: "Is a trial session included?", a: "A pre-wedding trial is included with the bridal package so we can perfect your base, eyes and draping together before the big day." },
  { q: "What courses do you offer?", a: "Professional HD & bridal certification, an airbrush machine masterclass, and self-grooming & everyday makeup classes — all small-batch and hands-on at the Bangalore studio." },
  { q: "Is there a visit charge, and what does pricing start at?", a: "Makeup starts at ₹4,999, and there's no visit charge for party, event or wedding bookings within Bangalore. Final pricing is confirmed free of charge at consultation." },
];
